module.exports = __webpack_public_path__ + "img/notebook.be5030ca.webp";